<script lang="ts">
	import { tokensAllowedForDepositUI } from '$lib/home/scwallet/config';
	import TokenBalanceRow from '$lib/home/scwallet/homeportfolio/TokenBalanceRow.svelte';
	import { tokensInWalletUSD } from '$lib/home/scwallet/store';
	import { firstLoadedUserBalances, userBalancesEnriched } from '$lib/home/store';
	import type { Token, TokenUI } from '$lib/types/tokens';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import {
		addDollarSign,
		getDecimalOfToken,
		getNumBackInUnits,
		sortInDescending
	} from '$lib/util/util';
	import MarginBalances from './MarginBalances.svelte';
	import TokenBalances from './TokenBalances.svelte';
	import type { Actions } from './types';

	const actions: Actions[] = ['Token Balance', 'Margin Balance'];
	export let selectedAction: Actions = 'Token Balance';

	function onSelectAction(action: Actions) {
		selectedAction = action;
	}
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-2xl"
	outerClassList="w-fit h-fit"
	innerClassList="bg-fx-gradient-8 min-w-[456px] p-6"
>
	<div class="flex justify-around gap-2">
		{#each actions as action}
			<button
				class={`${
					selectedAction == action
						? 'bg-fx-gradient-1 text-fx-grey-900'
						: 'bg-fx-gradient-8 text-fx-grey-200 border-fx-grey-500 border'
				} px-16 py-2 text-sm rounded-lg squircle-lg font-semibold`}
				on:click={() => onSelectAction(action)}
				on:keydown={() => onSelectAction(action)}>{action}</button
			>
		{/each}
	</div>

	<div class="border-t border-t-fx-grey-600 w-full my-4" />

	{#if selectedAction == 'Token Balance'}
		<TokenBalances />
	{:else if selectedAction == 'Margin Balance'}
		<MarginBalances />
	{/if}
</GradientBorder>
